import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    const lastHuertoId = localStorage.getItem('last_huerto_id');
    if (lastHuertoId) {
      navigate(`/huerto/${lastHuertoId}`);
    }
  }, [navigate]);

  return (
    <div className="animate-fade" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', maxWidth: '600px', margin: '0 auto', width: '100%', textAlign: 'center' }}>
      <div className="mb-4">
        <h1 style={{ fontSize: '3rem', marginBottom: '16px' }}>🌱 Huertolator</h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: '1.2rem', lineHeight: '1.5' }}>
          La plataforma colaborativa para gestionar tu huerto.
        </p>
      </div>
      
      <div style={{ backgroundColor: 'var(--surface-color)', padding: '32px', borderRadius: 'var(--radius-lg)', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)', marginTop: '24px' }}>
        <h2 style={{ marginTop: 0, marginBottom: '16px', fontSize: '1.5rem' }}>Acceso Privado</h2>
        <p style={{ marginBottom: '24px', color: 'var(--text-secondary)' }}>
          Para unirte a un huerto, necesitas un <strong>enlace de invitación</strong> proporcionado por el administrador.
        </p>
        <p style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
          Si ya te has unido a un huerto anteriormente en este navegador, serás redirigido automáticamente.
        </p>
      </div>
    </div>
  );
}
